module.exports = __webpack_public_path__ + "img/50_7.68ac588c.png";